import { render, staticRenderFns } from "./AdvancedPage.vue?vue&type=template&id=48289362&scoped=true&"
import script from "./AdvancedPage.vue?vue&type=script&lang=js&"
export * from "./AdvancedPage.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedPage.vue?vue&type=style&index=0&id=48289362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48289362",
  null
  
)

export default component.exports